/* eslint-disable no-unused-vars */
export enum RelationshipType {
  SPOUSE = 'Spouse',
  SON = 'Son',
  HUSBAND = 'Husband',
  NOT_APPLICABLE = 'N/A',
  DAUGHTER = 'Daughter',
  Family = 'Family',
  Parent = 'Parent',
  Sibling = 'Sibling',
  DOMESTIC_PARTNER = 'domesticPartner',
  EX_SPOUSE = 'exSpouse',
  FAMILY_CONTACT = 'FamilyContact',
  OTHER_CONTACT = 'other_contact',
  CHILD = 'Child',
  DOMESTIC_PARTNER_LABEL = 'Domestic Partner',
  EX_SPOUSE_LABEL = 'Ex spouse',
  FAMILY_CONTACT_LABEL = 'Family Contact',
  OTHER_CONTACT_LABEL = 'Other Contact',
}

export enum MaritalStatus {
  SINGLE = 'Single',
  MARRIED = 'Married',
  DIVORCED = 'Divorced',
  NOT_APPLICABLE = 'N/A',
}

export enum Gender {
  FEMALE = 'Female',
  MALE = 'Male',
  TRANSGENDER = 'Transgender',
  NON_BINARY = 'Non binary',
  QUEER = 'QUEER',
  NOT_APPLICABLE = 'N/A',
}

export enum Support {
  PAYROLL = 'pay_history',
  BENEFITS = 'benefits',
  TAX = 'tax_forms',
  hr_profile = 'hr_profile',
  PERSONAL_DETAILS = 'Personal Details',
}
export enum Ticket {
  ALL_TICKETS = 'All Tickets',
  OPEN = 'Open',
  IN_PROGRESS = 'In Progress',
  ON_HOLD = 'On Hold',
  SOLVED = 'Solved',
  CANCELLED = 'Cancelled',
}
export enum Level {
  LOW = 'Low',
  NORMAL = 'Normal',
  HIGH = 'High',
  URGENT = 'Urgent',
}
export enum RequestStatus {
  PENDING = 'PENDING',
  DENIED = 'DENIED',
  APPROVED = 'APPROVED',
}
export interface IDependent {
  id?: string | undefined;
  personnelNumber?: string | undefined;
  firstName: string;
  middleName?: string;
  lastName: string;
  relationshipType?: string;
  gender?: string;
  ssn?: string;
  birthDate?: string | Date;
  workPhone?: string;
  homePhone?: string;
  email?: string;
  isPersonalContact?: boolean;
  isEmergencyContact?: boolean;
  isBeneficiary?: boolean;
  isDependent?: boolean;
  address?: string;
  city?: string;
  state?: string;
  zipCode?: string;
  country?: string;
  county?: string;
  notes?: string;
  studentStatus?: boolean;
  smokerStatus?: boolean;
  requestStatus?: RequestStatus;
  relationship?: string;
  personId?: string;
  percentToPay?: string;
  notAllowedEditionAndDelition?: boolean;
}

export interface IBank {
  // isDefault: boolean | undefined;

  name: string;
  accountNumber: string;
  accountId: string;
  type: 'savingAccount' | 'checking' | string;
  // status?: 'active' | 'inactive';
  // routingNumber?: string;
  // bankName?: string;
}

export interface IDependentTable {
  id: string;
  firstName: string;
  lastName: string;
  birthDate: string | Date;
  workPhone: string;
  homePhone: string;
  isDependent: boolean;
  relationship: string;
  notAllowedEditionAndDelition?: boolean;
}
